//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            default: () => []
        },
        index: {
            type: [Number, String],
            default: 1
        }
    },
    methods: {
        _index(item) {
            return `${this.$device === 'pc' ? '0' : ''}${item.index || item.i+1}`
        }
    }
}
